/**
 * Custom Nostr event kinds for One Group to Rule Them All.
 *
 * Matchmaking kinds are ephemeral (20xxx) — relays may not store them long.
 * Game state is addressable (31xxx) — replaceable, one event per game.
 * Game moves are regular (1xxx) — immutable, folded into game state.
 */

/** A team's ready check for a specific game. Ephemeral. */
export const KIND_READY = 21337;

/** A team entering the matchmaking queue. Ephemeral. */
export const KIND_MATCHMAKING_QUEUE = 21338;

/** Match found pairing announcement. Ephemeral. */
export const KIND_MATCH_FOUND = 21339;

/** A single game move. Regular (immutable). */
export const KIND_GAME_MOVE = 1337;

/** Game state snapshot. Addressable, replaceable. d-tag = gameId. */
export const KIND_GAME_STATE = 31337;

/** Team ratings per game type. Addressable, replaceable. d-tag = "{teamId}:{gameType}". */
export const KIND_TEAM_RATINGS = 31338;

/** Team match history record. Regular. */
export const KIND_MATCH_RESULT = 1338;

/** Leaderboard snapshot. Addressable, replaceable. d-tag = "{gameType}:{period}". */
export const KIND_LEADERBOARD = 31339;

/** Tags used across game events */
export const TAG_GAME_TYPE = "g";    // Game type identifier: "tictactoe", "chess", etc.
export const TAG_TEAM_A = "ta";      // Team A community id (hex)
export const TAG_TEAM_B = "tb";      // Team B community id (hex)
export const TAG_GAME_ID = "i";      // Game ID (hex)
export const TAG_MOVE = "m";         // Move data (game-specific)
export const TAG_TURN = "t";         // Whose turn: "a" | "b"
export const TAG_WINNER = "w";       // Winner: "a" | "b" | "draw"
export const TAG_RATING = "r";       // Rating value
export const TAG_RATING_DELTA = "rd";// Rating change
export const TAG_READY = "ready";    // Ready status: "true" | "false"

/** Game type identifiers */
export const GAME_TICTACTOE = "tictactoe";

/** Supported games metadata */
export interface GameMeta {
  id: string;
  name: string;
  description: string;
  icon: string;
  minPlayers: number;
  maxPlayers: number;
}

export const SUPPORTED_GAMES: GameMeta[] = [
  {
    id: GAME_TICTACTOE,
    name: "Tic-Tac-Toe",
    description: "Classic 3x3 grid. Teams alternate turns claiming squares.",
    icon: "Hash",
    minPlayers: 2,
    maxPlayers: 8,
  },
];